import {
  formatScoreAsPercentage,
  getRatingColors,
} from "../../utils/myVendorRiskUtils";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function MyVendorRiskScoreBadge({
  score,
  rating,
  size = "sm",
  showPercentage = true,
  showRatingText = true,
  className = "",
}) {
  if (typeof score !== "number" || Number.isNaN(score)) {
    return (
      <span className={classNames("inline-flex items-center rounded-md bg-gray-100 px-2 py-1 text-xs text-gray-500", className)}>
        N/A
      </span>
    );
  }

  const colors = getRatingColors(rating);
  const percentage = formatScoreAsPercentage(score);
  const sizeClasses = {
    xs: "px-2 py-0.5 text-xs gap-1",
    sm: "px-2 py-1 text-xs gap-1.5",
    md: "px-2.5 py-1 text-sm gap-2",
  }[size];

  return (
    <span
      className={classNames(
        "inline-flex items-center rounded-md font-medium ring-1 ring-inset",
        colors.bg,
        colors.text,
        colors.ring,
        sizeClasses,
        className
      )}
      title={`${rating}: ${percentage}%`}
    >
      {showRatingText && <span>{rating}</span>}
      {showPercentage && <span className="font-semibold">{percentage}%</span>}
    </span>
  );
}

export function MyVendorRiskScoreBadgeWithDots({
  score,
  rating,
  size = "sm",
  showPercentage = true,
  showRatingText = true,
  maxDots = 5,
  className = "",
}) {
  if (typeof score !== "number" || Number.isNaN(score)) {
    return <MyVendorRiskScoreBadge score={score} size={size} className={className} />;
  }

  const colors = getRatingColors(rating);
  const percentage = formatScoreAsPercentage(score);
  const filledDots = Math.round(score * maxDots);
  const dotSize = size === "xs" ? "h-1.5 w-1.5" : "h-2 w-2";

  return (
    <div className={classNames("inline-flex items-center gap-2", className)}>
      <span
        className={classNames(
          "inline-flex items-center rounded-md font-medium ring-1 ring-inset",
          colors.bg,
          colors.text,
          colors.ring,
          size === "xs" ? "px-2 py-0.5 text-xs" : "px-2 py-1 text-xs"
        )}
      >
        {showRatingText && <span>{rating}</span>}
        {showPercentage && <span className="ml-1.5 font-semibold">{percentage}%</span>}
      </span>
      <div className="flex items-center gap-0.5">
        {Array.from({ length: maxDots }, (_, index) => (
          <div
            key={index}
            className={classNames("rounded-full", dotSize, index < filledDots ? colors.dot : "bg-gray-300")}
          />
        ))}
      </div>
    </div>
  );
}
